import React from 'react';

class SectionTwo extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {}

  render() {
    let page_id = this.props.page_id;
    let sectionData = this.props.pages.pageData[page_id] ? this.props.pages.pageData[page_id].acf.section_two : [];
    if(!Object.keys(sectionData).length) return [];

    return (
        <section className="section section-layout-1">
            <div className="main-container">
                <div className="layout layout-1">
                    <div className="grid">
                        <div className="contentArea"> 
                            <h3 className="title-md" style= {{ color: sectionData.text_color }}>{sectionData.heading}</h3>
                            <div className="desc title-sm" dangerouslySetInnerHTML={{__html:sectionData.content}} />
                        </div>
                        <figure>
                            <img src={sectionData.image.url}  alt={sectionData.image.alt}  title={sectionData.image.title} />
                        </figure>
                    </div>
                </div>
            </div>
        </section>
    );
  }
}

export default SectionTwo;


// WEBPACK FOOTER //
// ./src/components/Practice/SectionTwo.js